import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { CalendarGroupItemExt } from '../../../../models/calendar-group-item.model';
import { CalendarGroup } from '../../../../models/calendar-group.model';
import { CalendarGroupItemService } from '../../../../services/calendar-group-item/calendar-group-item.service';
import { CalendarGroupService } from '../../../../services/calendar-group/calendar-group.service';

@Component({
  selector: 'app-form-calendar-group',
  templateUrl: './form-calendar-group.component.html',
  styleUrls: ['./form-calendar-group.component.css']
})
export class FormCalendarGroupComponent implements OnInit {

  @Input() calendarGroupId: string;
  form: FormGroup;
  editMode: boolean;
  addItemDialog = false;
  calendarGroup: CalendarGroup;
  calendarGroupItems: CalendarGroupItemExt[] = [];
  fields: any;
  itemFields: any;
  public invalidSubmit: boolean;
  addCalendarTitle: string;

  constructor(
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private srvCalendarGroup: CalendarGroupService,
    private srvCalendarGroupItem: CalendarGroupItemService
  ) { }

  ngOnInit() {

    this.translate.get([
      'calendarList.add_title',
    ]).subscribe((res) => {
      this.addCalendarTitle = res['calendarList.add_title'];
    });

    this.srvCalendarGroup.getFields().subscribe(res => {
      this.fields = res;
    });

    this.calendarGroupId = this.activatedRoute.snapshot.params['calendarGroupId'];

    this.editMode = this.calendarGroupId !== undefined && this.calendarGroupId !== null && this.calendarGroupId !== '';

    if (this.editMode) {
      let calendarGroupCall: Observable<any>  = this.srvCalendarGroup.get(this.calendarGroupId);
      this.getAll();
      Observable.zip(calendarGroupCall)
        .subscribe(([calendarGroup, calendarItems]) => {

          this.calendarGroup = calendarGroup;

          this.form = this.fb.group({
            code: new FormControl(this.calendarGroup.code),
            description: new FormControl(this.calendarGroup.description)
          });
        });
    } else {

      this.form = this.fb.group({
        code: new FormControl(''),
        description: new FormControl('')
      });
    }
  }

  getAll() {
    this.srvCalendarGroupItem.getAllByGroupId(this.calendarGroupId).subscribe( calendarGroupItems => {
      this.calendarGroupItems = calendarGroupItems;
    });
  }

  calendarGroupItemAdded() {
    this.addItemDialog = false;
    this.getAll();
  }

  deleteGroupItem(groupItem: CalendarGroupItemExt) {
    this.srvCalendarGroupItem.delete(groupItem).subscribe( res =>
      this.getAll()
    );
  }

  openAddItemDialog() {
    this.addItemDialog = true;
  }

  closeDialog() {
    this.addItemDialog = false;
  }

  save() {
    if (!this.form.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;
    const calendarGroup = new CalendarGroup();
    calendarGroup.code = this.form.get('code').value;
    calendarGroup.description = this.form.get('description').value;
    if (this.editMode) {
      calendarGroup.id = +this.calendarGroupId;
      this.srvCalendarGroup.put(calendarGroup).subscribe(() => {
        this.router.navigateByUrl ('calendargroups');
      });
    } else {
      this.srvCalendarGroup.post(calendarGroup).subscribe( () => {
        this.router.navigateByUrl ('calendargroups');
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/calendar-group/form-calendar-group/form-calendar-group.component.ts